"use client"

import { playUiClickSound } from "@/lib/game-audio"
import { useEffect } from "react"

const CLICKABLE_SELECTOR =
  "button, a, [role='button'], [data-audio-click='true']"

export function GlobalAudioFeedback() {
  useEffect(() => {
    const onPointerDown = (event: PointerEvent) => {
      if (event.button !== 0) return

      const target =
        event.target instanceof Element
          ? event.target.closest<HTMLElement>(CLICKABLE_SELECTOR)
          : null

      if (!target) return
      if (target instanceof HTMLButtonElement && target.disabled) return
      if (target.getAttribute("aria-disabled") === "true") return

      playUiClickSound()
    }

    document.addEventListener("pointerdown", onPointerDown, {
      capture: true,
    })

    return () => {
      document.removeEventListener("pointerdown", onPointerDown, {
        capture: true,
      })
    }
  }, [])

  return null
}
